import Vue from "vue"
import { getInfo } from "@/api/signup/index"
import { getGroupBalance } from "@/api/balance/index"
const User = {
  state: {
    token: "",
    userInfo: {},
    allshow: false,
    balance: "0.00"
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
      Vue.ls.set("token", token)
    },
    SET_INFO: (state, userInfo) => {
      state.userInfo = userInfo
      Vue.ls.set("userInfo", userInfo)
    },
    SET_BALANCE: (state, balance) => {
      state.balance = balance
    },
    REMOVE_TOKEN: state => {
      state.token = ""
      Vue.ls.set("token", "")
    }
  },
  actions: {
    GetInfo({ commit }) {
      return new Promise(resolve => {
        getInfo()
          .then(response => {
            const result = response
            commit("SET_INFO", result)
            resolve(response)
          })
          .catch(() => { })
      })
    },
    // 获取用户余额
    getBalance({ commit }) {
      return new Promise((resolve, reject) => {
        getGroupBalance()
          .then(response => {
            const result = response
            commit("SET_BALANCE", result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  }
}
export default User
